import React, { useState } from "react";
import { Button, Form, NavLink } from "react-bootstrap";
import { toast } from 'react-toastify';
import axios from "axios";
import Constants from "../frontLayout/Variables/Constants";
import { Link } from "react-router-dom";

const SignupComponent = ({ setIsOpen, setShowLogin, actionPerform }) => {
    const [formData, setFormData] = useState({
        name: '',
        email: '',
        password: '',
        confirm_password: '',
        // Optional address captured at signup (stored via useraddress/create after registration)
        address_name: "",
        country: "",
        address: "",
        city: "",
        state: "",
        postal_code: "",
    });

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prevData) => ({
            ...prevData,
            [name]: value,
        }));
    };

    const validateName = () => {
        const name = formData.name;
        if (!name) {
            toast.clearWaitingQueue();
            toast.dismiss();
            toast.error("Name is Required!");
            return false;
        }
        if (!/^[a-zA-Z\s]*$/.test(name)) {
            toast.clearWaitingQueue();
            toast.dismiss();
            toast.error("Name must contain only letters and spaces");
            return false;
        }
        return true;
    };

    const validateEmail = () => {
        const email = formData.email;
        const emailPattern = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i;
        if (!email) {
            toast.clearWaitingQueue();
            toast.dismiss();
            toast.error("Email address is required");
            return false;
        }
        if (!emailPattern.test(email)) {
            toast.clearWaitingQueue();
            toast.dismiss();
            toast.error("Invalid email address");
            return false;
        }
        return true;
    };

    const validatePassword = () => {
        const password = formData.password;
        const minLength = 8;
        if (!password) {
            toast.clearWaitingQueue();
            toast.dismiss();
            toast.error("Password is required");
            return false;
        }
        if (password.length < minLength) {
            toast.clearWaitingQueue();
            toast.dismiss();
            toast.error(`Password must be at least ${minLength} characters long`);
            return false;
        }
        return true;
    };

    const confirmPasswordValidation = () => {
        const { password, confirm_password } = formData;
        if (!confirm_password) {
            toast.clearWaitingQueue();
            toast.dismiss();
            toast.error("Confirm Password is required");
            return false;
        }
        if (confirm_password !== password) {
            toast.clearWaitingQueue();
            toast.dismiss();
            toast.error("Passwords do not match");
            return false;
        }
        return true;
    };

    const validateAddressIfProvided = () => {
        const anyAddressValue = ["address_name", "country", "address", "city", "state", "postal_code"].some(
            (key) => String(formData?.[key] || "").trim() !== ""
        );

        if (!anyAddressValue) return true;

        const requiredKeys = ["address_name", "country", "address", "city", "postal_code"];
        const missing = requiredKeys.filter((key) => String(formData?.[key] || "").trim() === "");

        if (missing.length) {
            toast.clearWaitingQueue();
            toast.dismiss();
            toast.error("Please fill all required address fields (name, country, address, city, postal code).");
            return false;
        }

        return true;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {

            if (
                validateName() &&
                validateEmail() &&
                validatePassword() &&
                confirmPasswordValidation() &&
                validateAddressIfProvided()
            ) {
                const payload = {
                    name: formData.name,
                    email: formData.email,
                    password: formData.password,
                };
                const res = await axios.post(Constants.postUrls.signup, payload);
                if (res.data.status === "success") {

                    toast.clearWaitingQueue();
                    toast.dismiss();
                    toast.success(res.data.message, {
                        style: { backgroundColor: 'green', color: 'white' },
                    });
                    localStorage.setItem("token", res.data.token);

                    const anyAddressValue = ["address_name", "country", "address", "city", "state", "postal_code"].some(
                        (key) => String(formData?.[key] || "").trim() !== ""
                    );

                    if (anyAddressValue) {
                        const addressPayload = {
                            address_name: formData.address_name,
                            country: formData.country,
                            address: formData.address,
                            city: formData.city,
                            state: formData.state,
                            postal_code: formData.postal_code,
                            is_default: "yes",
                        };

                        try {
                            await axios.post(Constants.postUrls.addAddress, addressPayload, {
                                headers: { Authorization: res.data.token },
                            });
                        } catch (addrErr) {
                            toast.error("Signup succeeded, but address could not be saved. You can add it later from Address.");
                            console.error(addrErr);
                        }
                    }

                    await actionPerform();
                    setIsOpen(false);
                    // window.location.reload();
                } else {
                    toast.clearWaitingQueue();
                    toast.dismiss();
                    toast.error(res.data.message);
                }
            }
        } catch (error) {
            try {
                toast.clearWaitingQueue();
                toast.dismiss();
                toast.error(error.message);
                const { status, message } = error.response.data
                if (status === 401 && message === "Unauthorized!") {
                    localStorage.removeItem("token");
                    window.location.href = "/";
                }
            } catch (error) {
                toast.clearWaitingQueue();
                toast.dismiss();
                toast.error(error.message);
            }
        }
    };
    return (<>
        <div className="d-flex align-items-center my-4">
            <h1 className="fs-36 fw-400 m-0">Please Sign Up first! 👋</h1>
        </div>
        <Form onSubmit={handleSubmit}>
            <Form.Group className="mb-4" controlId="formBasicName">
                <Form.Label className="fs-16 fw-400">Name</Form.Label>
                <Form.Control
                    className="fs-16 fw-400"
                    type="text"
                    name="name"
                    onChange={handleChange}
                    value={formData.name}
                    onBlur={validateName}
                    placeholder="Enter Name"
                />
            </Form.Group>
            <Form.Group className="mb-4" controlId="formBasicEmail">
                <Form.Label className="fs-16 fw-400">Email</Form.Label>
                <Form.Control
                    className="fs-16 fw-400"
                    type="email"
                    name="email"
                    onChange={handleChange}
                    value={formData.email}
                    onBlur={validateEmail}
                    placeholder="Example@email.com"
                />
            </Form.Group>

            <div className="mb-3">
                <h2 className="fs-16 fw-400 m-0">Address (optional)</h2>
            </div>

            <Form.Group className="mb-4" controlId="formAddressName">
                <Form.Label className="fs-16 fw-400">Address Name</Form.Label>
                <Form.Control
                    className="fs-16 fw-400"
                    type="text"
                    name="address_name"
                    onChange={handleChange}
                    value={formData.address_name}
                    placeholder="Home / Office"
                />
            </Form.Group>

            <Form.Group className="mb-4" controlId="formCountry">
                <Form.Label className="fs-16 fw-400">Country / Region</Form.Label>
                <Form.Control
                    className="fs-16 fw-400"
                    type="text"
                    name="country"
                    onChange={handleChange}
                    value={formData.country}
                    placeholder="Country / Region"
                />
            </Form.Group>

            <Form.Group className="mb-4" controlId="formAddressLine">
                <Form.Label className="fs-16 fw-400">Address</Form.Label>
                <Form.Control
                    className="fs-16 fw-400"
                    type="text"
                    name="address"
                    onChange={handleChange}
                    value={formData.address}
                    placeholder="Street, building, apartment"
                />
            </Form.Group>

            <div className="row">
                <div className="col-md-6">
                    <Form.Group className="mb-4" controlId="formCity">
                        <Form.Label className="fs-16 fw-400">City</Form.Label>
                        <Form.Control
                            className="fs-16 fw-400"
                            type="text"
                            name="city"
                            onChange={handleChange}
                            value={formData.city}
                            placeholder="City"
                        />
                    </Form.Group>
                </div>
                <div className="col-md-6">
                    <Form.Group className="mb-4" controlId="formState">
                        <Form.Label className="fs-16 fw-400">State</Form.Label>
                        <Form.Control
                            className="fs-16 fw-400"
                            type="text"
                            name="state"
                            onChange={handleChange}
                            value={formData.state}
                            placeholder="State"
                        />
                    </Form.Group>
                </div>
                <div className="col-md-6">
                    <Form.Group className="mb-4" controlId="formPostalCode">
                        <Form.Label className="fs-16 fw-400">Postal Code</Form.Label>
                        <Form.Control
                            className="fs-16 fw-400"
                            type="text"
                            name="postal_code"
                            onChange={handleChange}
                            value={formData.postal_code}
                            placeholder="Postal Code"
                        />
                    </Form.Group>
                </div>
            </div>

            <Form.Group className="mb-4" controlId="formBasicPassword">
                <Form.Label className="fs-16 fw-400">Password</Form.Label>
                <Form.Control
                    className="fs-16 fw-400"
                    type="password"
                    name="password"
                    value={formData.password}
                    onChange={handleChange}
                    onBlur={validatePassword}
                    placeholder="At least 8 characters"
                />
            </Form.Group>
            <Form.Group className="mb-4" controlId="formBasicConfirmPassword">
                <Form.Label className="fs-16 fw-400">Confirm Password</Form.Label>
                <Form.Control
                    className="fs-16 fw-400"
                    type="password"
                    name="confirm_password"
                    value={formData.confirm_password}
                    onChange={handleChange}
                    onBlur={confirmPasswordValidation}
                    placeholder="At least 8 characters"
                />
            </Form.Group>
            <div className="d-grid mb-4">
                <Button variant="warning" type="submit">Sign Up</Button>
            </div>
            <div className="divider_or">
                <span>or</span>
            </div>
            <div className="text-center mt-4">
                <p className="fs-16 fw-400">Already have an account? <span className="text_brand_sepia_color" style={{ cursor: "pointer" }} onClick={() => setShowLogin(true)}>Sign In</span></p>

            </div>
        </Form>
    </>)
}

export default SignupComponent
